export default __webpack_public_path__ + "static/media/livingstone.ba8de958.jpg";